import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import "../styleSheets/features.css";
import "../styleSheets/buttons.css";

function Features(){
    const {t} = useTranslation("common");
    const featureCards = {
        "Security & Control": [
            {
                title: t("pageBody.features.SecurityAndControl.Storage.title"),
                text: t("pageBody.features.SecurityAndControl.Storage.text")
            },
            {
                title: t("pageBody.features.SecurityAndControl.Verification.title"),
                text: t("pageBody.features.SecurityAndControl.Verification.text")
            },
            {
                title: t("pageBody.features.SecurityAndControl.TimedDelivery.title"),
                text: t("pageBody.features.SecurityAndControl.TimedDelivery.text")
            },
            {
                title: t("pageBody.features.SecurityAndControl.VisibilityControl.title"),
                text: t("pageBody.features.SecurityAndControl.VisibilityControl.text")
            },
            {
                title: t("pageBody.features.SecurityAndControl.WebAccess.title"),
                text: t("pageBody.features.SecurityAndControl.WebAccess.text")
            },
            {
                title: t("pageBody.features.SecurityAndControl.PrivacyControl.title"),
                text: t("pageBody.features.SecurityAndControl.PrivacyControl.text")
            }
        ],

        "Customization & Legacy": [
            {
                title: t("pageBody.features.CustomizationAndLegacy.Personalization.title"),
                text: t("pageBody.features.CustomizationAndLegacy.Personalization.text")
            },
            {
                title: t("pageBody.features.CustomizationAndLegacy.Media.title"),
                text: t("pageBody.features.CustomizationAndLegacy.Media.text")
            },
            {
                title: t("pageBody.features.CustomizationAndLegacy.Wisdom.title"),
                text: t("pageBody.features.CustomizationAndLegacy.Wisdom.text")
            },
            {
                title: t("pageBody.features.CustomizationAndLegacy.Alerts.title"),
                text: t("pageBody.features.CustomizationAndLegacy.Alerts.text")
            },
            {
                title: t("pageBody.features.CustomizationAndLegacy.Capsules.title"),
                text: t("pageBody.features.CustomizationAndLegacy.Capsules.text")
            },
            {
                title: t("pageBody.features.CustomizationAndLegacy.Milestones.title"),
                text: t("pageBody.features.CustomizationAndLegacy.Milestones.text")
            }
        ],

        "Connection & Support": [
            {
                title: t("pageBody.features.ConnectionAndSupport.Sharing.title"),
                text: t("pageBody.features.ConnectionAndSupport.Sharing.text")
            },
            {
                title: t("pageBody.features.ConnectionAndSupport.PrioritySupport.title"),
                text: t("pageBody.features.ConnectionAndSupport.PrioritySupport.text")
            },
            {
                title: t("pageBody.features.ConnectionAndSupport.FollowUp.title"),
                text: t("pageBody.features.ConnectionAndSupport.FollowUp.text")
            },
            {
                title: t("pageBody.features.ConnectionAndSupport.PlanningTools.title"),
                text: t("pageBody.features.ConnectionAndSupport.PlanningTools.text")
            },
            {
                title: t("pageBody.features.ConnectionAndSupport.Support.title"),
                text: t("pageBody.features.ConnectionAndSupport.Support.text")
            },
            {
                title: t("pageBody.features.ConnectionAndSupport.GivingBack.title"),
                text: t("pageBody.features.ConnectionAndSupport.GivingBack.text")
            }
        ]
    };

    const [selectedCategory, setSelectedCategory] = useState("Security & Control");
    const selectCategoryButton=(catSelected: string)=> {
        setSelectedCategory(catSelected);
    }
    return (
        <section className="section-features" aria-labelledby="features-title">
            <div className="container-features">
                <div className="key-features-section">
                    <h2 id="features-title" className="key-features-title">{t("pageBody.features.cardsTitle")}</h2>
                    <div className="line-div"/>
                    <div className="key-features-text">{t("pageBody.features.cardsText")}
                    </div>
                </div>
                <div className="feature-cards-section">
                    <div className="category-selector">
                        <button
                            type="button"
                            className={`btn btn--pill ${selectedCategory === "Security & Control" ? "btn--pill-light" : "btn--pill-dark"}`}
                            onClick={() => selectCategoryButton("Security & Control")}
                        >
                            {t("pageBody.features.securityAndControl")}
                        </button>
                        <button
                            type="button"
                            className={`btn btn--pill ${selectedCategory === "Customization & Legacy" ? "btn--pill-light" : "btn--pill-dark"}`}
                            onClick={() => selectCategoryButton("Customization & Legacy")}
                        >
                            {t("pageBody.features.customizationAndLegacy")}
                        </button>
                        <button
                            type="button"
                            className={`btn btn--pill ${selectedCategory === "Connection & Support" ? "btn--pill-light" : "btn--pill-dark"}`}
                            onClick={() => selectCategoryButton("Connection & Support")}
                        >
                            {t("pageBody.features.connectionAndSupport")}
                        </button>
                    </div>
                    <div className="grid">
                        {featureCards[selectedCategory as keyof typeof featureCards].map((card, index) => (
                            <div className="feature-card" key={index}>
                                <div className="feature-card-title">{card.title}</div>
                                <div className="feature-card-text">{card.text}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Features;
